import { react2angular } from 'react2angular';
import template from './feedback_list.html';
import { featureEnabled } from '../../../../utils';
import checkbox from '../../../../components/Checkbox';

angular
  .module('bb.appointments.feedback')
  .component('bbFeedbackList', {
    bindings: {},
    controller: bbFeedbackListCtrl,
    controllerAs: 'vm',
    template,
  })
  .component('antdCheckbox', react2angular(checkbox, ['checked', 'onChange']));

bbFeedbackListCtrl.$inject = [
  'FeedbackService',
  'ErrorService',
  'ModalService',
  'AppointmentConfigService',
  '$routeParams',
  '$route',
  '$location',
  '$scope',
  '$q',
];

function bbFeedbackListCtrl(
  FeedbackService,
  ErrorService,
  ModalService,
  AppointmentConfigService,
  $routeParams,
  $route,
  $location,
  $scope,
  $q,
) {
  const vm = this;
  vm.featureEnabled = featureEnabled;
  vm.selectedFeedback = {};
  vm.feedbackSelectFn = {};

  vm.allSelected = () => {
    return Object.values(vm.selectedFeedback).every(v => v);
  };
  vm.selectAll = e => {
    Object.keys(vm.selectedFeedback).forEach(k => {
      vm.selectedFeedback[k] = e.target.checked;
    });
    vm.selectedAppointments = vm.feedbacks
      .filter(f => vm.selectedFeedback[f.id])
      .map(f => f.appointment);
    $scope.$digest();
  };

  vm.$onInit = function () {
    $q.all([
      FeedbackService.getFeedbackList($routeParams.listingId),
      AppointmentConfigService.getListingAppointmentConfig(
        $routeParams.listingId,
      ),
    ])
      .then(function ([{ listing, feedbacks }, config]) {
        vm.appointmentConfig = config;
        vm.listing = listing;
        vm.feedbacks = feedbacks;
        feedbacks.forEach(feedback => {
          vm.selectedFeedback[feedback.id] = false;
          vm.feedbackSelectFn[feedback.id] = e => {
            vm.selectedFeedback[feedback.id] = e.target.checked;
            vm.selectedAppointments = vm.feedbacks
              .filter(f => vm.selectedFeedback[f.id])
              .map(f => f.appointment);
            $scope.$digest();
          };
        });
        vm.feedbacks.sort((a, b) => {
          return new Date(b.submittedAt) - new Date(a.submittedAt);
        });
        vm.selectedAppointments = [];
        vm.listingLink = `#/listing/${vm.listing.id}/view`;
        if ($routeParams?.appointmentId) {
          ModalService.openAppointmentModal(
            $routeParams.appointmentId,
            vm.listing.id,
            'feedback',
          );
        }
      })
      .catch(function (err) {
        const { data } = err;
        if (data.type === 'FORBIDDEN_ACTION') {
          data.message =
            'You do not have permissions to view this page. Please contact support@brokerbay.com for more information.';
        }
        ErrorService.toastyHTTPErr({ ...err, data });
        $location.path(`/listing/${$routeParams.listingId}/view`);
      })
      .finally(function () {
        vm.loaded = true;
      });
  };

  vm.openPreviewToHistory = async appointmentId => {
    const updated = await ModalService.openAppointmentModal(
      appointmentId,
      vm.listing.id,
      'history',
    );
    if (updated) $route.reload();
  };

  // Open the preview modal to the feedback tab to easily send reminder
  vm.openPreviewToFeedback = function (appointmentId) {
    ModalService.openAppointmentModal(
      appointmentId,
      vm.listing.id,
      'feedback',
    ).then(function (updated) {
      if (updated) $route.reload();
    });
  };

  vm.hasListingContacts = () =>
    vm.appointmentConfig.contacts.some(({ type }) => {
      return ['Seller', 'Tenant', 'Landlord/Manager'].includes(type);
    });

  vm.tooltipText = () => {
    if (!vm.selectedAppointments.length)
      return 'Please select feedback option(s) below';
    if (!vm.hasListingContacts())
      return 'There is no listing contact(s) to send feedback to';
  };
}
